import { ArticlePresentationFormat, HemingwayLinkType } from '../types.js';
export function isAdvicePageLink(link) {
    var _a;
    if ('__typename' in link && 'sitemapNode' in link) {
        return (link.__typename === HemingwayLinkType.Sitemap &&
            !!((_a = link === null || link === void 0 ? void 0 : link.sitemapNode) === null || _a === void 0 ? void 0 : _a.presentationFormat) &&
            advicePageFormats.includes(link.sitemapNode.presentationFormat));
    }
    if ('presentationFormat' in link) {
        return !!link.presentationFormat && advicePageFormats.includes(link.presentationFormat);
    }
    return false;
}
export const advicePageFormats = [
    ArticlePresentationFormat.AdvicePage,
    ArticlePresentationFormat.BrandedPage,
    ArticlePresentationFormat.AdviceHub,
    ArticlePresentationFormat.CorporatePage,
];
//# sourceMappingURL=isAdvicePageLink.js.map